import '@polymer/iron-icon/iron-icon.js';
import '@polymer/paper-spinner/paper-spinner-lite.js';
import { html } from '@polymer/polymer/lib/utils/html-tag.js';
import { PolymerElement } from '@polymer/polymer/polymer-element.js';
class ConnectionStateIcon extends PolymerElement {
  static get template() {
    return html`
      <style>
        :host {
          position: relative;
          height: 40px;
          margin: 0;
          width: 0px;
          opacity: 0;
          transition:
            opacity 0.3s,
            width 0.3s;
        }
        :host([showSpinner]) iron-icon {
          padding: 8px;
        }
        :host([visible]) {
          opacity: 1;
          width: 40px;
          margin: 0 8px;
        }
        iron-icon {
          color: var(--connection-state-icon-color, white);
          padding: 6px;
          height: inherit;
          width: inherit;
          box-sizing: border-box;
          transition: padding 0.3s;
        }
        paper-spinner-lite {
          position: absolute;
          top: 0;
          left: 0;
          height: inherit;
          width: inherit;
          --paper-spinner-color: var(--connection-state-icon-color, white);
        }
      </style>
      <iron-icon icon="[[icon]]"></iron-icon>
      <paper-spinner-lite active="[[showSpinner]]"></paper-spinner-lite>
    `;
  }

  static get is() {
    return 'connection-state-icon';
  }
  static get properties() {
    return {
      downloading: {
        type: Boolean,
        value: false
      },
      error: {
        type: Object
      },
      icon: {
        type: 'String'
      },
      online: {
        type: Boolean,
        value: false
      },
      showSpinner: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      },
      visible: {
        type: Boolean,
        value: false,
        reflectToAttribute: true
      }
    };
  }
  static get observers() {
    return ['stateChanged(online, uploading, downloading, error, waiting)'];
  }
  ready() {
    super.ready();
    this.addEventListener('click', (e) => this.toast());
  }
  stateChanged() {
    if (this.hideTimeout) clearTimeout(this.hideTimeout);
    this.hideTimeout = null;

    this.showSpinner = this.uploading || this.downloading;

    this.message = {};

    if (this.error) {
      this.visible = true;
      this.icon = 'error-outline';
      this.message.text = this.error.message || 'An unknown error was encountered while trying to sync...';
      this.message.button = true;
      this.message.buttonText = 'HELP';
      this.message.buttonCallback = () => this.dispatchEvent(new CustomEvent('show-offline-help'));
    } else if (this.downloading) {
      this.visible = true;
      this.icon = 'cloud-download';
      this.message.text = 'You are currently caching data';
    } else if (this.uploading) {
      this.visible = true;
      this.icon = 'cloud-upload';
      this.message.text = 'You are currently syncing data';
    } else if (this.online) {
      this.icon = 'cloud-done';
      this.message.text = 'You are currently online';
      this.hideTimeout = setTimeout(() => {
        this.visible = false;
      }, 3000);
    } else if (this.waiting) {
      this.visible = true;
      this.icon = 'cloud-queue';
      this.message.text = 'Waiting to sync data';
    } else {
      this.visible = true;
      this.icon = 'cloud-off';
      this.message.text = 'You are currently offline';
      // this.toast('You have gone offline');
    }
  }
  toast(message) {
    this.dispatchEvent(new CustomEvent('toast', { detail: message || this.message }));
  }
}
window.customElements.define(ConnectionStateIcon.is, ConnectionStateIcon);
